module.exports = __webpack_public_path__ + "static/webapp-f6eeed0f08def51ae7c9c0328349872f.webm";